export default __webpack_public_path__ + "static/media/review@3x.fb94c31c.png";